module.exports = __webpack_public_path__ + "media/158.245dec8d.mp3";